// React
import { Link } from '@tanstack/react-router';

// Components
import { LetterSwapPingPong } from '../ui/LetterSwap/LetterSwap';

// Misc
import { motion } from 'motion/react';

type AnnouncementBannerProps = {
  label: string;
  title: string;
  href: string;
};

export const AnnouncementBanner = ({ label, title, href }: AnnouncementBannerProps) => {
  const isExternal = href.startsWith('http');

  const content = (
    <motion.div
      initial={{ opacity: 0, y: -8 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.4, ease: 'easeOut' }}
      className="flex items-center justify-center gap-2 whitespace-nowrap px-ds-24 py-ds-12"
    >
      <span className="font-['Inter'] text-[10px] font-bold uppercase leading-normal text-blue-800">
        {label}
      </span>
      <span className="font-['Signifier'] text-[20px] font-extralight leading-[28px] text-blue-800" aria-hidden="true">
        |
      </span>
      <span className="font-['Signifier'] text-[20px] font-extralight leading-[28px] text-blue-1000">
        <LetterSwapPingPong
          label={title}
          staggerFrom="first"
          staggerDuration={0.02}
          transition={{ type: 'spring', duration: 0.5 }}
        />
      </span>
    </motion.div>
  );

  if (isExternal) {
    return (
      <a
        href={href}
        target="_blank"
        rel="noopener noreferrer"
        className="block"
        aria-label={`${label}: ${title}`}
      >
        {content}
      </a>
    );
  }

  return (
    <Link
      to={href}
      className="block"
      aria-label={`${label}: ${title}`}
    >
      {content}
    </Link>
  );
};
